function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#009ca6",
  d: "M0,864V160q0-7.86.77-15.68t2.3-15.53q1.54-7.71,3.82-15.24t5.29-14.78q3-7.26,6.71-14.19T27,71.11q4.38-6.54,9.36-12.61T46.86,46.86q5.56-5.55,11.64-10.54T71.11,27q6.54-4.37,13.47-8.07t14.19-6.71q7.26-3,14.78-5.29t15.24-3.82q7.71-1.53,15.53-2.3T160,0H864q7.86,0,15.68.77t15.53,2.3q7.71,1.54,15.24,3.82t14.78,5.29q7.26,3,14.19,6.71T952.89,27q6.54,4.38,12.61,9.36t11.64,10.54q5.55,5.56,10.54,11.64T997,71.11q4.37,6.54,8.07,13.47t6.71,14.19q3,7.26,5.29,14.78t3.82,15.24q1.53,7.71,2.3,15.53T1024,160V864q0,7.86-.77,15.68t-2.3,15.53q-1.54,7.71-3.82,15.24t-5.29,14.78q-3,7.26-6.71,14.19T997,952.89q-4.38,6.54-9.36,12.61t-10.54,11.64q-5.57,5.55-11.64,10.54T952.89,997q-6.54,4.37-13.47,8.07t-14.19,6.71q-7.26,3-14.78,5.29t-15.24,3.82q-7.71,1.53-15.53,2.3T864,1024H160q-7.86,0-15.68-.77t-15.53-2.3q-7.71-1.54-15.24-3.82t-14.78-5.29q-7.26-3-14.19-6.71T71.11,997q-6.54-4.38-12.61-9.36T46.86,977.14q-5.55-5.57-10.54-11.64T27,952.89q-4.37-6.54-8.07-13.47t-6.71-14.19q-3-7.26-5.29-14.78T3.07,895.21Q1.54,887.5.77,879.68T0,864Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M623.16,410.42a60,60,0,0,0-13-16.47,62.15,62.15,0,0,0-19.35-11.49,64.13,64.13,0,0,0-23.34-4.33H280.33V792.29h94.21V664.82h193a65,65,0,0,0,23.34-4.32,60,60,0,0,0,19.35-11.84,65.87,65.87,0,0,0,13-16.43,38.54,38.54,0,0,0,4.89-18.79v-184A40,40,0,0,0,623.16,410.42Zm-88.9,63.23V573.82a8.9,8.9,0,0,1-.21,1c-.56,6.61-2.85,11.31-6.92,14a19.33,19.33,0,0,1-10.74,2.75H374.12V453.05H516.39c9.8,0,15.5,4.62,17.24,13.69.11.66.27,1.3.36,2,0,.2,0,.45,0,.68.11,1.16.22,2.35.22,3.64Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M679.39,664V378h92.47V664Z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  x: 679.39,
  y: 271.44,
  width: 92.47,
  height: 70.88
});

function SvgAppIconPunditImpact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconPunditImpact);
export default __webpack_public_path__ + "static/media/appIconPunditImpact.68194e04.svg";
export { ForwardRef as ReactComponent };